import { useState } from 'react';

import { ListItemButton, ListItemIcon, Menu } from '@mui/material';

import VectorImage from '~components/media/vectorImage';
import { Dimens } from '~themes';

import menuRowSx from '../menuRowSx';
import { SideMenuDropdown } from '../types';
import { MenuLi } from './menuPrimitives';
import PageRow from './pageRow';

interface Props {
	dropdown: SideMenuDropdown;
	/** Highlight the icon like a selected row when a child page is active. */
	active: boolean;
}

/**
 * A dropdown rendered for the collapsed rail: just the icon, whose children
 * open in a flyout `Menu` anchored to it (see the mobile mock).
 */
const DropdownFlyout = ({ dropdown, active }: Props) => {
	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
	const isOpen = Boolean(anchorEl);

	return (
		<MenuLi block>
			<ListItemButton
				onClick={(event) => setAnchorEl(event.currentTarget)}
				sx={menuRowSx({
					active: active || isOpen,
					height: Dimens.fixed(44),
					width: Dimens.fixed(44),
				})}
			>
				{dropdown.iconName && (
					<ListItemIcon
						sx={{
							minWidth: Dimens.fixed(24),
							minHeight: Dimens.fixed(24),
							justifyContent: 'center',
						}}
					>
						<VectorImage name={dropdown.iconName} size={Dimens.fixed(24)} />
					</ListItemIcon>
				)}
			</ListItemButton>
			<Menu
				open={isOpen}
				anchorEl={anchorEl}
				onClose={() => setAnchorEl(null)}
				onClick={() => setAnchorEl(null)}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				transformOrigin={{ vertical: 'top', horizontal: 'left' }}
				slotProps={{
					paper: {
						sx: { mt: Dimens.spacingSm, borderRadius: Dimens.radiusMd },
					},
					list: {
						sx: {
							minWidth: Dimens.spacing12xl,
							display: 'flex',
							flexDirection: 'column',
							gap: Dimens.spacingXs,
							p: Dimens.spacingXs,
						},
					},
				}}
			>
				{dropdown.pages.map((page) => (
					<PageRow key={page.label} page={page} showLabel />
				))}
			</Menu>
		</MenuLi>
	);
};

export default DropdownFlyout;
